import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { Button, Dropdown, Layout, message, Result, Tooltip } from 'antd';
import {
  MenuUnfoldOutlined,
  MenuFoldOutlined,
} from '@ant-design/icons';
import { isMobile } from 'react-device-detect';
import { Scrollbars } from 'react-custom-scrollbars-2';
import { dispatch, useGlobalState } from '../../../store/state';
import { AiOutlineUser } from 'react-icons/ai';
import { IoIosHelpBuoy, IoMdListBox } from 'react-icons/io';
import { IoLogOutOutline, IoNotificationsOutline } from 'react-icons/io5';
import { AppLogout } from '../../../utils/AppLogout';
import InfluencerProfileComponent from './InfluencerProfileComponent';
import { VerifyRequestUser } from '../../../apis/Influencer/Profile/VerifyRequestUser';
import { GetNotifications } from '../../../apis/Influencer/Profile/GetNotifications';
import { ReactSVG } from 'react-svg';
// import './InfluencerTopHeaderComponent.styles.scss';

const { Header } = Layout;
const InfluencerTopHeaderComponent = ({ layoutControl, toggle, getProfileData }) => {
  const [user] = useGlobalState('user');
  const [profDraw, setProfDraw] = useState(false);
  const [notify, setNotify] = useState([]);
  const [verifyStatus, setVerifyStatus] = useState({
    verified: false,
    requestState: '',
  });

  const showDraw = (e) =>{
    e.preventDefault();
    setProfDraw(true);
  };
  const hideDraw = () =>{
    setProfDraw(false);
  };

  const verifyUser = () =>{
    VerifyRequestUser(user.accessToken).then(({ status, response })=>{
      console.log('user Verification', response);
      if (status === 200) {
        message.success('Verification Request sent to admin');
        setVerifyStatus(true);
        getProfileData(); // refetch profile details
      } else {
        message.error('There is some issue while verification');
      }
    });
  };

  const userNotifications = () =>{
    GetNotifications(user.accessToken).then(({ status, response }) =>{
      console.log('Notifications', response);
      if (status === 200) {
        setNotify(response.notifications || []);
      } else {
        console.log('There is some issue while getting notifications');
      }
    });
  };

  useEffect(()=>{
    userNotifications();
  }, []);
  useEffect(()=>{
    setVerifyStatus({
      verified: user.verified,
      requestState: user.verification_request,
    });
  }, [user]);

  // const [prof]
  const menuUserDropdown = (
    <div className="header_user_dropdown">
      <div className="header_user_dropdown_details d-flex align-items-center">
        <div className="header_user_dropdown_details--avatar">
          <img src={user.profilepicture}
            className="img-fluid"
            alt={user.firstname} />
        </div>
        <div className="header_user_dropdown_details--name">
          <h5>{user.firstname + ' ' + user.lastname}</h5>
          <a href="#"
            onClick={showDraw}>Edit Profile</a>
        </div>
      </div>
      <div className="header_user_dropdown_links">
        {/* <a href="#"><IoIosHelpBuoy size={20}/> Help & Support</a>
                <a href="#"><IoMdListBox size={20}/> Terms & Conditions</a> */}
        <a href="https://flynt.social/privacy.php"
          target="_blank"
          rel="noreferrer"><IoIosHelpBuoy size={20}/> Privacy Policy</a>
        <a href="https://flynt.social/terms-and-conditions.php"
          target="_blank"
          rel="noreferrer"><IoMdListBox size={20}/> Terms &amp; Conditions</a>
        <a href="#"
          onClick={AppLogout}><IoLogOutOutline size={20}/> Logout</a>
      </div>
    </div>
  );
  const menuNotificationDropdown = (
    <div className="header_notify_dropdown">
      <h3 className="header_notify_dropdown--title">Notifications</h3>
      <Scrollbars style={{ height: 300 }}>
        <ul className="header_notify_dropdown_list">
          {
            notify.length ?(
              notify.map(({ _id, content, updatedAt, picture }, index)=>(
                <li key={_id+index}
                  className="header_notify_dropdown_list_each d-flex align-items-center">
                  <div className="header_notify_dropdown_list_each--logo">
                    <img src={picture ? picture : 'https://via.placeholder.com/112x100?text=No+Image'}
                      className="img-fluid"
                      alt="Notification Image" />
                  </div>
                  <div className="header_notify_dropdown_list_each--content">
                    <h4>{content.title}</h4>
                    <p>{content.description}</p>
                    <span>{updatedAt? moment(updatedAt).fromNow(): 'N/A'}</span>
                  </div>
                </li>
              ))
            ):(
              <Result title="No Notifications"
                status="info"/>
            )
          }
          {/* <li className="header_notify_dropdown_list_each d-flex align-items-center">
                        <div className="header_notify_dropdown_list_each--logo">
                            <img src="/images/brand-logo.svg" className="img-fluid" alt="Nike" />
                        </div>
                        <div className="header_notify_dropdown_list_each--content">
                            <h4>New Nike Products Campign</h4>
                            <p>Your Application for the new Nike campign accepted for final Scrutiny.</p>
                            <span>3 Min ago</span>
                        </div>
                    </li>
                    <li className="header_notify_dropdown_list_each d-flex align-items-center">
                        <div className="header_notify_dropdown_list_each--logo">
                            <img src="/images/brands-logo/ADI_BLACK.webp" className="img-fluid" alt="Nike" />
                        </div>
                        <div className="header_notify_dropdown_list_each--content">
                            <h4>Adidas Campign created</h4>
                            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit.</p>
                            <span>56 Min ago</span>
                        </div>
                    </li>
                    <li className="header_notify_dropdown_list_each d-flex align-items-center">
                        <div className="header_notify_dropdown_list_each--logo">
                            <img src="/images/brand-logo.svg" className="img-fluid" alt="Nike" />
                        </div>
                        <div className="header_notify_dropdown_list_each--content">
                            <h4>Flynt Security updates</h4>
                            <p>Amet quas animi placeat laudantium beatae! Voluptas, impedit voluptate</p>
                            <span>1 Day ago</span>
                        </div>
                    </li>
                    <li className="header_notify_dropdown_list_each d-flex align-items-center">
                        <div className="header_notify_dropdown_list_each--logo">
                            <img src="/images/brands-logo/ADI_BLACK.webp" className="img-fluid" alt="Nike" />
                        </div>
                        <div className="header_notify_dropdown_list_each--content">
                            <h4>New Nike Products Campign</h4>
                            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit.</p>
                            <span>2 Days ago</span>
                        </div>
                    </li> */}
        </ul>
      </Scrollbars>
    </div>
  );
  return (
    <>
      <Header
        className="common_header"
        style={{
          position: 'fixed',
          // zIndex: 3,
          // width: layoutControl.collapsed ? 'calc(100% - 80px)':'calc(100% - 270px)',
          width: layoutControl.collapsed ? (
            isMobile ? '100%' : 'calc(100% - 80px)'
          ):(
            isMobile ? '100%' : 'calc(100% - 270px)'
          ),
          padding: 0,
          // left: layoutControl.collapsed ? '80px':'270px',
          left: layoutControl.collapsed ? (
          // isMobile ? '0' : '80px'
            isMobile ? '0' : '80px'
          ):(
            isMobile ? '0' : '270px'
          ),
          transition: 'all 0.2s',
        }}
      >
        <div className="d-flex align-items-center">
          <div className="col-md-5">
            {React.createElement(layoutControl.collapsed ? MenuUnfoldOutlined : MenuFoldOutlined, {
              className: 'trigger px-0',
              onClick: toggle,
            })}
            {
              isMobile ?
                <span className="d-inline-block pl-3 pr-1">
                  {/* <img src="/images/brand-logo-small.png" style={{maxWidth:35}} alt="" /> */}
                  <ReactSVG src="/images/brand-logo.svg"/>
                </span>:
                null
            }
          </div>
          <div className="col-md-7 text-right">
            {
              (!verifyStatus.verified && verifyStatus.requestState === '') ?(
                <Tooltip title="This Account is still not verified by Admin, click here and get verified">
                  <Button className="common_button outlined small mr-4 danger"
                    onClick={verifyUser}>Verify Me</Button>
                </Tooltip>
              ): verifyStatus.requestState === 'pending' ? (
                <Tooltip title="Your request is still pending, Admin will verfiy your request within a week.">
                  <Button className="common_button outlined small mr-4 warning"> Verification Pending</Button>
                </Tooltip>
              ):null

            }
            <Dropdown overlay={menuNotificationDropdown}
              trigger={['click']}>
              <div className="header_user--trigger mr-4">
                {
                  notify.length ?
                    <span className="notify-ticker">
                      {notify.length > 9 ? '9+' : notify.length}
                    </span>:
                    null
                }
                <IoNotificationsOutline size={22}/>
              </div>
            </Dropdown>
            <Dropdown overlay={menuUserDropdown}
              trigger={['click']}>
              <div className="header_user--trigger">
                <AiOutlineUser size={22}/>
              </div>
            </Dropdown>
          </div>
        </div>
      </Header>
      {/* @note: drawer for profile */}
      <InfluencerProfileComponent visible={profDraw}
        onClose={hideDraw}/>
    </>
  );
};

export default InfluencerTopHeaderComponent;
